// src/components/landing/StatsBanner.tsx
'use client'

import { BookOpen, Timer, Sparkles, Calculator } from 'lucide-react'

type Stat = {
  icon: React.ReactNode
  value: string
  label: string
}

// All four stats here must be verifiable product facts. If you add a new
// one, make sure it's something a user can confirm by using the product —
// not a social-proof claim. Pre-launch we don't have real user numbers
// (avg score gain, satisfaction, total students) so those don't belong.
const STATS: Stat[] = [
  {
    icon: <BookOpen className="h-5 w-5 text-brand-ink" />,
    value: '5,000+',
    // Total Question rows in the production database (rounded down).
    label: 'practice questions',
  },
  {
    icon: <Timer className="h-5 w-5 text-brand-ink" />,
    value: '134 min',
    // Real Digital SAT length — matches TEST_CONFIGS.sat.totalTimeMin.
    label: 'real exam pacing',
  },
  {
    icon: <Sparkles className="h-5 w-5 text-brand-ink" />,
    value: 'Adaptive',
    // Module 2 difficulty changes based on M1 performance, mirroring the
    // College Board's Digital SAT adaptive format.
    label: 'Module 2 format',
  },
  {
    icon: <Calculator className="h-5 w-5 text-brand-ink" />,
    value: 'Desmos',
    // Built-in graphing calculator on every Math question.
    label: 'built-in calculator',
  },
]

export default function StatsBanner() {
  return (
    <section className="px-5 py-12 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-border bg-card/60 p-6 text-center shadow-sm shadow-black/20 transition hover:border-border hover:bg-card/80"
            >
              <div className="mb-3 flex justify-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card">
                  {s.icon}
                </div>
              </div>
              <div className={`text-3xl font-bold tracking-tight text-brand-ink md:text-4xl`}>
                {s.value}
              </div>
              <div className="mt-2 text-sm text-muted-foreground">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
